module.exports = __webpack_public_path__ + "img/book-14.3a2786f5.png";